import { gql } from "@apollo/client";

export const BULK_CREATE_CYCLE_COUNT_LOGS = gql`
    mutation bulkCreateCycleCountLogs($dateCounted: Date!, $logs: [CycleCountLogInputType]!) {
        bulkCreateCycleCountLogs(dateCounted: $dateCounted, logs: $logs) {
            cycleCountLogs {
                id
            }
        }
    }
`